// extracted by mini-css-extract-plugin
export default {"invalid":"---------packages-corgi-x-src-components-StatusMessage-StatusMessage-module__invalid"};